import { Email, Sms, NotificationsOff, Group } from '@material-ui/icons'
import { CalendarCheck } from 'mdi-material-ui'
import { FileDocument, FileDocumentEdit, Help, MessageReplyText } from 'mdi-material-ui'

export default (entityType, id) => {
  const entityTypes = {
    eventgoaloptions: {
      default: CalendarCheck,
      '1': Group,
      '2': Group,
      '3': FileDocumentEdit,
      '4': Email,
      '5': Email,
      '6': Email,
      '7': MessageReplyText,
      '8': Email,
      '9': Group,
      '10': NotificationsOff,
      '11': FileDocument,
      '12': FileDocument,
      '13': FileDocument,
      '14': Group,
      '15': Group,
      '16': Sms,
      '17': Sms,
      '18': Sms,
      '19': Email,
    },
  }

  if (entityType) {
    if (id) {
      return (
        entityTypes[entityType][id] ||
        entityTypes[entityType]['default'] ||
        Help
      )
    }
    if (entityTypes[entityType]) {
      return entityTypes[entityType]['default'] || Help
    }
  }
  return Help
}
